declare var glAddRemovedGroup: any;

import { Component, OnInit, Input } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreProductAssignmentService } from '../../services/point-store-product-assignment.service';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import '../../../../../../../../ClearView WebPortal/Scripts/Admin/GroupListUpdate.js';

@Component({
  selector: 'cv-point-store-product-assignment',
  templateUrl: './point-store-product-assignment.component.html',
  styleUrls: ['./point-store-product-assignment.component.scss']
})
export class PointStoreProductAssignmentComponent implements OnInit {

  pspes = null;
  permission_inner_right_display = [];
  assignOptions = [{
    coreAssignAtLevel: 1,
    coreAssignAtType: "emp",
    coreAssignAtOption: "normal"
  }];
  LocalizationMessages = null;
  showAssingTool = false;
  groupListSource = null;
  showall = false;
  empgrouptypes = [];

  @Input() next: (args: number) => void;
  @Input() cancel: () => void;

  constructor(
    private cvLocalizationService: CVLocalizationService,
    private pointStoreProductEditService: PointStoreProductEditService,
    private pointStoreProductAssignmentService: PointStoreProductAssignmentService,
  ) {
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;//
  }

  ngOnInit(): void {
    this.loadLocalization();
    //$(document).off("glGroupAdded", handle_glGroupAdded); //make sure to remove any prior glGroupAdded events first so there aren't multiple events being caught for this
    $(document).on("glGroupAdded", this.handle_glGroupAdded); //Now wire the glGroupAdded event.
  }

  async loadLocalization() {
    const result = await this.cvLocalizationService.GetSection("MarketPlace_Management");
    if (result) {
      this.LocalizationMessages = result;
    }
  }

  assignButtonClick() {
    this.showAssingTool = true;
  };

  handle_glGroupAdded(e) {
    if (e.source != this.groupListSource)
      return;

    // $scope.$evalAsync(function () {
    //   this.pointStoreProductAssignmentService.addAssignmentLazy(e.gID, e.gLvl);
    // });
  };

  removeAssignments(item) {
    this.pointStoreProductAssignmentService.removeAssignment(item);
    /*Add Group to aspx control*/
    new glAddRemovedGroup(item.EmpGroupID, item.EmpGroupLevel);

    if (item.EmpGroupID == 0 && item.EmpGroupLevel == 5) {
      this.pspes.modifiedPointStoreProduct.AssignedGroups = false;

      this.pointStoreProductAssignmentService.glAddGroups();
    }
  };

  addRemoveAllAssignmentGroup() {
    this.pointStoreProductAssignmentService.addRemoveAllAssignmentGroup();
  };

  // loadGroupListUpdate() {
  //   PointStoreService.RenderPointStoreAssignmentControl(
  //     function (result) {
  //       var breakpoint = 1;
  //     },
  //     function (error) {
  //       showErrorMessage(error.get_message());
  //     }
  //   );
  // };

  getTitle(title) {
    if (this.LocalizationMessages != undefined && this.LocalizationMessages != null) {
      let test = Object.entries(this.LocalizationMessages).find(([key, value]) => value === 'Remove_Assignment');
      return test;
    }
    return "Remove Assignment";
  }

  /**
   * 
   * @param eventData info related to what was selected in modal
   */
  onAssignmentsChanged(eventData?: any[]) {
    const obj = {
      empAssignAll: false,//true if the user selects something in the modal otherwise false
      emp: [],
      rec: [],
      attr: [],
      coreAssignAtType: null,
      coreAssignAtLevel: 0
    };
      if (eventData && eventData.length) {
          for (let listItem of eventData) {
              if (listItem.BaseGroupType == 0)
                  obj.emp.push(listItem);
              else if (listItem.BaseGroupType == 1)
                  obj.rec.push(listItem);
              else if (listItem.AttributeValueID != null)
                  obj.attr.push(listItem);
          }
          if (obj.attr.length > 0) {
              obj.attr = [...new Map(obj.attr.map(item => [item['AttributeValueName'], item])).values()]
          }
      } else if (eventData == null || eventData.length <= 0) {
          obj.empAssignAll = false;
      } else {
          obj.empAssignAll = true;
      }
    this.pointStoreProductAssignmentService.pspef.modifiedPointStoreProduct.PointStoreProductAllAssignments = obj;
  }

  /**
   * Returns the localized string for the given key or defaultValue, if it doesn't exist.
   * @param key Key for the localization string in the Pipeline_Configuration section.
   * @param defaultValue String to return if there's no such key in the localizationStringMap
   */
  getLocalizationString(key: string, defaultValue: string) {
    if (this.LocalizationMessages) {
      if (this.LocalizationMessages.has(key)) {
        return this.LocalizationMessages.get(key);
      }
    }
    return defaultValue;
  }


  // $scope.$on('AssignToolMarketPlaceSaveEvt', function(event, data) {
  //     $scope.$emit("AssignToolCloseEvt");
  //     $scope.$broadcast("AssignToolCloseEvt");

  //     var obj = {
  //       emp: [],
  //       rec: [],
  //       attr: [],
  //       coreAssignAtType: null,
  //       coreAssignAtLevel: 0
  //     };
  //     for (var i = 0; i < data.list.length; i++) {
  //       if (data.list[i].BaseGroupType == 0) obj.emp.push(data.list[i]);
  //       else if (data.list[i].BaseGroupType == 1) obj.rec.push(data.list[i]);
  //       else if (data.list[i].AttributeValueID != null) obj.attr.push(data.list[i]);
  //     }

  //     obj.coreAssignAtType = data.type;
  //     obj.coreAssignAtLevel = data.lvl;

  //     if (ctrl.datatransfer != null && ctrl.datatransfer.assignOptions != null)
  //       obj.assignOptions = angular.copy(ctrl.datatransfer.assignOptions);

  //     if (!(data === undefined || data === null))
  //       ctrl.datatransfer = angular.copy(obj);

  //     if (ctrl.retainselected == true) {
  //       ctrl.retainList = angular.copy(ctrl.assignList);
  //     }

  //     console.log(obj);
  //     //this.pointStoreProductAssignmentService.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.push(obj);
  //     this.pointStoreProductAssignmentService.pspef.modifiedPointStoreProduct.PointStoreProductAllAssignments = obj;


  //     //$scope.$emit('AssignToolMarketPlaceSaveEvt', { 'list': ctrl.lst });

  //     return;
  //   });

}
